import { Component, Input, OnInit } from '@angular/core';

//* Models
import { TProductTypeQuantity } from '@models/cart.model';

//* Services
import { ProductsValidationsService, TProductType } from '@services/products-validations.service';

//* Shared
import { DEFAULT_IMAGE_URL } from '@shared/utils';
import { imageHandling } from '@shared/imageHandling';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TitleCasePipe, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-product-summary',
  templateUrl: './product-summary.component.html',
  styleUrls: ['./product-summary.component.scss'],
  standalone: true,
  imports: [LazyLoadImageModule, MatFormFieldModule, TitleCasePipe, CurrencyPipe]
})
export class ProductSummaryComponent implements OnInit {

  @Input() product: any;

  public defaultImage: string = DEFAULT_IMAGE_URL;

  public productQuantity: number;
  public productType: TProductType;
  public productTypeQuantity: TProductTypeQuantity;
  public productImage: string;
  constructor(
    private productsValidationsService: ProductsValidationsService
  ) { }

  ngOnInit(): void {
    if (!this.product.image_url.includes('_c')) {
      const imgHa = imageHandling(this.product.image_url, 'small', '.webp');
      this.productImage = imgHa;
    }

    let unit = this.product.unit.toLowerCase();

    this.productType = this.productsValidationsService.productCartTypeValidation(unit, this.product.weight);

    switch (this.productType) {
      case 'grammage':
        this.productTypeQuantity = 'grammage';
        this.productQuantity = this.product?.quantity * 1000;
        break;
      case 'pza':
        this.productTypeQuantity = 'pza';
        this.productQuantity = this.product.quantity;
        break;
      case 'granel':
        this.productTypeQuantity = 'granel';
        this.productQuantity = this.product?.quantity * 1000;
        break;
      case 'pza-grammage':
        unit = this.product.unit.toLowerCase();

        if (unit === 'grammage') {
          this.productTypeQuantity = 'grammage';
          this.productQuantity = this.product?.quantity * 1000;
        } else {
          this.productTypeQuantity = 'pza';
          this.productQuantity = this.product.quantity / Number.parseFloat(this.product.weight);
          this.productQuantity = Number.parseInt(this.productQuantity.toFixed(2));
        }
        break;
    }

  }

}
